export default "__VITE_ASSET__VSwzmngwwfY_G1TEv$SLQQ__"